import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { GoSync } from 'react-icons/go';
import { useTranslation } from 'react-i18next';
import Accordion from '../components/Accordion';
import ImageShow from '../components/ImageShow';
import Link from '../components/Link';
import { useReferralInfoQuery } from '../store';
import { env } from '../constants/env-config';

const linksToLanguage = {
  ua: (
    <>
       <Link
        className="w-[50px] flex justify-center items-center rounded-full h-[50px] bg-blue-250 mr-6"
        to="/">
        <ImageShow
          className="m-0"
          image={{ url: 'twitter', label: 'twitter' }}
        />
      </Link>
      <Link
        className="w-[50px] flex justify-center items-center rounded-full h-[50px] bg-blue-950 mr-6"
        to="/">
        <ImageShow
          className="m-0"
          image={{ url: 'facebook', label: 'facebook' }}
        />
      </Link>
      <Link
        className="w-[50px] flex justify-center items-center rounded-full h-[50px] bg-blue-350 mr-6"
        to="/">
        <ImageShow
          className="m-0"
          image={{ url: 'telegram', label: 'telegram' }}
        />
      </Link>
      <Link
        className="w-[50px] flex justify-center items-center rounded-full h-[50px] bg-purple-650 mr-6"
        to="/">
        <ImageShow
          className="m-0"
          image={{ url: 'viber', label: 'viber' }}
        />
      </Link>
    </>
  )
}

function ReferralPage() {
  const [referralUrl, setRefferalUrl] = useState('');
  const { t } = useTranslation();
  const { data, error, isFetching } = useReferralInfoQuery();

  const [isCopied, setIsCopied] = useState(false);
   
  const [mobileScreen, setMobileScreen] = useState(false);

  useEffect(() => {
    if (data) {
      setRefferalUrl(window.location.origin + '?referral=' + data.code);
    }
  }, [data]);

  const instructions = (
    <ol className="list-decimal">
      <li>{t('referral.terms.term1')}</li>
      <li>{t('referral.terms.term2')}</li>
      <li>{t('referral.terms.term3')}</li>
      <li>{t('referral.terms.term4')}</li>
      <li>{t('referral.terms.term5')}</li>
    </ol>
  );

  const items = [
    {
      id: 0,
      label: <>{t('referral.accordionTitle').replace('"Податкові друзі"', '')}{ mobileScreen && <br /> } "{t('referral.friends')}</>,
      content: instructions,
    },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await navigator.clipboard.writeText(referralUrl);
      setIsCopied(true);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);

  
  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth < 460);
    };
    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  let content;
  if (isFetching) {
    content = <GoSync className="animate-spin inline-block text-green-700" />;
  } else if (error) {
    console.error('Error loading data...');
  } else {
    content = (
      <>
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-[10px]">
          <div className="p-7 flex flex-col rounded-[30px] text-white bg-gradient-to-r from-cyan-650 to-cyan-75 xs:p-5">
            <ImageShow
              className="w-[24px] mb-8"
              image={{ url: 'user', label: 'user' }}
            />
            <p className="text-sm xs:mt-auto">{t('referral.registered')}</p>
            <p className="text-2xl">{data.referralCount}</p>
          </div>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 xs:p-5">
            <ImageShow
              className="w-[24px] mb-8"
              image={{ url: 'card-gray', label: 'card gray' }}
            />
            <p className="text-sm xs:mt-auto">{t('referral.paidService')}</p>
            <p className="text-2xl">{data.referralPayedServiceCount}</p>
          </div>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 xs:p-5">
            <ImageShow
              className="w-[24px] mb-8"
              image={{ url: 'star', label: 'star' }}
            />
            <p className="text-sm  xs:mt-auto">{t('referral.totalBonuses')}</p>
            <p className="text-2xl">{data.acquiredBonuses}</p>
          </div>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 xs:p-5">
            <ImageShow
              className="w-[24px] mb-8"
              image={{ url: 'half-star', label: 'half star' }}
            />
            <p className="text-sm  xs:mt-auto">{t('referral.remainingBonuses')}</p>
            <p className="text-2xl">{data.balanceBonuses}</p>
          </div>
        </div>
        <div className="flex flex-row mt-16 xs:mt-10">
          <div className="xl:basis-1/2 relative pb-10">
            <label className="text-gray-350 pb-7">
              {t('referral.referralLink')}
            </label>
            <form
              onSubmit={handleSubmit}
              className="relative flex bg-gray-75 max-w-[360px] rounded-lg mt-2 mb-5">
              <input
                className="border-2 border-gray-75 rounded-lg p-5 w-[245px] h-[50px]"
                type="text"
                defaultValue={referralUrl}
              />
              <button 
                className={
                  clsx(
                    `text-sm text-gray-350 w-[115px] right-1 top-1 m-1 rounded-md`, 
                    isCopied 
                    ? 'bg-grey-450 shadow-sm text-black' 
                    : 'bg-gradient-to-r from-cyan-650 to-cyan-75 text-white hover:bg-gradient-to-r hover:from-cyan-900 hover:to-cyan-650'
                  )
                }
              >
                {isCopied ? t('referral.copied') : t('referral.copy')}
              </button>
            </form>
            <div className="flex">
              <Link
                className="w-[50px] flex justify-center items-center rounded-full h-[50px] bg-gray-450 mr-6"
                to="/">
                <ImageShow
                  className="m-0"
                  image={{ url: 'email', label: 'email' }}
                />
              </Link>
             {
              linksToLanguage[env.LANGUAGE]
             }
            </div>
            <Accordion className="mt-10 block xl:hidden" items={items} />
            {/* <Link
              className="absolute bottom-0 text-cyan-650 underline text-sm"
              to="/referral-info">
              Бажаєте стати партнером?
            </Link> */}
          </div>
          <div className="xl:basis-1/2 border-l-[#f2f2f2] hidden xl:block border-l border-solid pl-10 py-2 pr-10">
            <h3 className="text-gray-350 pb-4 -ml-4 xs:whitespace-normal">
              {t('referral.accordionTitle')}
            </h3>
            {instructions}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="page">
      <h1 className="text-black text-2xl xs:text-lg">{t('sidebar.links.taxFriends')}</h1>
      <p className="mb-20 xs:text-sm xs:mb-8">
        “{t('referral.accordionTitle')}”
      </p>
      {content && content}
    </div>
  );
}

export default ReferralPage;
